import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

export const StyledItemCard = styled.div`
    background-color: var(${GLOBAL_STYLE_CONFIG.variable('cart-item', 'bg-color')}, ${(props) => props.theme.cardItem.backgroundColor});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('cart-item', 'border-radius')}, ${(props) => props.theme.cardItem.borderRadius});
    border: 1px solid var(${GLOBAL_STYLE_CONFIG.variable('cart-item', 'border-color')}, ${(props) => props.theme.cardItem.borderColor});
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('cart-item', 'font-family')}, inherit);
    // font-size: var(${GLOBAL_STYLE_CONFIG.variable('cart-item', 'font-size')}, clamp(12px, 1vw, 14px));
    display: grid;
    gap: 8px;
    overflow: hidden;
    position: relative;
    padding: 10px;
    grid-template-columns: 100%;
    align-items: center;

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price')} {
        align-items: center;

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price-old')} {
            font-size: clamp(12px, 3vw, 16px);
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price-current')} {
            font-size: clamp(14px, 3vw, 18px);
        }
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-head-title')} {
        color: ${(props) => props.theme.cardItem.titleColor};
        text-overflow: ellipsis;
        font-size: clamp(12px, 1vw, 14px);
        line-height: 120%; /* 16.8px */
        text-align: left;
        font-weight: 500;
        font-family: inherit;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-head')} {
        display: grid;
        grid-template-columns: 75px 1fr;
        align-items: center;
        gap: clamp(15px, 4vw, 32px);
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details')} {
        display: grid;
        grid-template-columns: repeat(2, 1fr) auto;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
    }


    @media (min-width: 768px) {
        grid-template-columns: 50% calc(50% - 10px);
        .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details')} {
            grid-template-columns: 40% 40% auto;
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price')} {
            align-items: flex-start;
            width: max-content;
            max-width: 100%;
        }

    }

`